/** Home of a learner without a plan (D-110): the Academy Pass of their country and what the
 * free trial still offers (mini mock of the exam being prepared). */

import { useAcademyAccountRetrieve } from "@agencyos/api-client";
import { buttonClass } from "@agencyos/ui-web";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { SectionTitle } from "../ui";
import { PassCard } from "./PassCard";
import { TrialCard } from "./TrialCard";

export function HomeOffer() {
  const { t } = useTranslation();
  const account = useAcademyAccountRetrieve({ query: { retry: false } });
  const data = account.data?.status === 200 ? account.data.data : undefined;
  if (!data?.offer.available) return null;
  return (
    <section className="ac-section" aria-labelledby="academy-plan">
      <SectionTitle id="academy-plan">{t("academySales.plans.title")}</SectionTitle>
      <div className="as-plans__grid">
        <PassCard
          offer={data.offer}
          country={data.country || "CM"}
          compact
          action={
            <Link className={buttonClass("primary", { block: true })} to={data.can_renew ? "/academy/plans?renew=1" : "/academy/plans"}>
              {data.can_renew ? t("academySales.pass.renew") : t("academySales.pass.choose")}
              <ArrowRight aria-hidden size={18} />
            </Link>
          }
        />
        <TrialCard offer={data.offer} trial={data.trial} />
      </div>
    </section>
  );
}
